<template>
  <form @submit.prevent="submit($event, query)" id="news_form">
    <kt-form-section is_first>
      <kt-row>
        <kt-col lg="6" md="6" xs="12">
          <kt-form-group>
            <kt-form-label for="subject">{{ $t('label.subject') }}</kt-form-label>
            <kt-form-control id="subject" name="subject" v-model="query.subject"></kt-form-control>
          </kt-form-group>
        </kt-col>
      </kt-row>
    </kt-form-section>

    <kt-form-section>
      <kt-row>
        <kt-col lg="12" md="12" xs="12">
          <kt-form-group>
            <kt-form-label for="newscontent">{{ $t('label.newscontent') }}</kt-form-label>
              <ckeditor :editor="editor"
                        v-model="query.newscontent"
                        :config="editorConfig"
                        tag-name="textarea"
              >
              </ckeditor>
<!--            <kt-form-textarea id="newscontent" name="newscontent" v-model="query.newscontent"></kt-form-textarea>-->
          </kt-form-group>
        </kt-col>
      </kt-row>
    </kt-form-section>

    <kt-form-section>
      <kt-row></kt-row>
    </kt-form-section>

    <kt-form-action class="mt-4">
      <kt-button
        class="m-2"
        size="md"
        variant="success"
        type="submit"
        v-bind:wide="true"
        id="submit_btn"
      >{{ $t('panel.profile.update.wizard.form.btn.submit') }}</kt-button>
    </kt-form-action>
  </form>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {editorConfig} from '@/constants/ckeditorConfigs'
import { subcategories } from "@/constants/subcategories";
import $ from "jquery";
import Inputmask from "inputmask";
import { mapGetters, mapState } from "vuex";
import { i18n } from "@/plugins/i18n";

export default {
  props: {
    submit: {
      default: () => {
        //console.log("The default submit method, nothing to do!");
      },
      type: Function,
    },
    query: {
      default() {
        return {
        };
      },
      type: Object,
    },
  },
    data() {
      return {
          editor: ClassicEditor,
          editorData: '',
          editorConfig: editorConfig,
      }
    },
    components: {
        ckeditor: CKEditor.component
    },
};
</script>

<style scoped>
.label-file {
  border: 1px solid #ccc;
  cursor: pointer;
  min-width: 200px;
  width: fit-content;
}
</style>